module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-300.0a7c6df0.woff2";